/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Magiclinktitle2Inputs */

const zh_auth_magiclinktitle2 = /** @type {(inputs: Auth_Magiclinktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一键登录`)
};

const en_auth_magiclinktitle2 = /** @type {(inputs: Auth_Magiclinktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with magic link`)
};

const es_auth_magiclinktitle2 = /** @type {(inputs: Auth_Magiclinktitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión con enlace mágico`)
};

/**
* | output |
* | --- |
* | "Sign in with magic link" |
*
* @param {Auth_Magiclinktitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_magiclinktitle2 = /** @type {((inputs?: Auth_Magiclinktitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Magiclinktitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_magiclinktitle2(inputs)
	if (locale === "en") return en_auth_magiclinktitle2(inputs)
	return es_auth_magiclinktitle2(inputs)
});
export { auth_magiclinktitle2 as "auth_magicLinkTitle" }